// String values are also used for class names
export enum CheckboxStatus {
  Unchecked = 'unchecked',
  Checked = 'checked',
  Indeterminate = 'indeterminate',
}
